import once from './once';
export const getIsLocal = once(() => {
  const domain = window.location.host;
  return domain.startsWith('local') && !domain.includes('hsappstatic');
});